import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./OurStory.css";

const paragraphVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const OurStory = () => {
  const paragraphs = [
    `Our journey began in 2007 as a modest warehousing and builder company and has since evolved into VCNR Group - a purpose-driven, multi-sector enterprise transforming lives and landscapes across India. Guided by enduring values and a singular vision, VCNR has expanded its presence across seven high-impact sectors: Builder, Technology, Healthcare, Agrotech, Gold & Diamond, Aerospace, and Educational Institutions. At the heart of this growth is Narasimhamurthy, our founder, visionary, and driving force, whose belief in long-term value over short-term gains has steered VCNR with quiet resilience and clarity of purpose. His leadership embodies the philosophy that growth is not just about numbers, but about meaning.`
    // `From shaping skylines with iconic developments to driving digital transformation, from making quality healthcare accessible to reimagining agriculture for the future, every VCNR venture begins with a dream - to grow, to serve, and to last. Our expansion into lifestyle and luxury, and now into pioneering fields like aerospace and education, reflects our restless spirit to keep evolving. Beyond industries and innovations, this is a story about people - about listening before building, creating with empathy, and empowering communities to become stronger. Through initiatives like the Hitachinthana Charitable Trust, we continue to give back with compassion and purpose. VCNR is not just a company - it’s a movement of possibility, fueled by passion and anchored in a deep sense of responsibility, working to leave the world better than we found it.`
  ];

  return (
    <section className="ourstory-section">
      <div className="center-icon-container">
        {/* <p className="scroll-down">Scroll down</p> */}
      </div>

      <div className="ourstory-content">
        <h2 className="section-title">Our Story</h2>
        <p className="section-subtitle">A Legacy Built to Last. A Future Designed to Inspire. </p>

        <div className="section-paragraphs">
          {paragraphs.map((text, index) => {
            const [ref, inView] = useInView({ triggerOnce: false, threshold: 0.3 });
            return (
              <motion.p
                key={index}
                ref={ref}
                variants={paragraphVariant}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                className="animated-paragraph"
              >
                {text}
              </motion.p>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurStory;
